/* MODULES */
import Vue from "vue";
import Router from "vue-router";
/* COMPONENTS */
import Home from "./views/Home";
import Profile from "./views/Profile";
import AccountUserNew from "./views/Account/AccountUserNew";
import AccountActivate from "./views/Account/AccountActivate";
import AccountCreatorNew from "./views/Account/AccountCreatorNew";
import AccountAskForPasswordReset from "./views/Account/AccountAskForPasswordReset";
import AccountSubmitNewPassword from "./views/Account/AccountSubmitNewPassword";
import Page404 from "./views/Page404";
import searchRoutes from "./search/router/searchRoutes";
import OrganizationRoutes from "./organization/routes/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true,
    },
    {
      path: "/km/:kilometers",
      name: "AroundXKilometers",
      props: true,
      redirect: { name: "home" },
    },
    {
      path: "/profile/:username",
      name: "profile",
      component: Profile,
    },
    {
      path: "/account/password/reset/",
      name: "account/password/reset",
      component: AccountAskForPasswordReset,
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: "/account/password/new/:uid/:token",
      name: "account/password/new",
      component: AccountSubmitNewPassword,
      props: true,
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: "/account/user/new/:uuid",
      name: "account/user/new",
      component: AccountUserNew,
      props: true,
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: "/account/activate/:uid/:token",
      name: "account/activate",
      component: AccountActivate,
      props: true,
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: "/account/creator/new/",
      name: "account/creator/new",
      component: AccountCreatorNew,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    ...searchRoutes,
    ...OrganizationRoutes,
    {
      path: "*",
      name: "404",
      component: Page404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // If Query destinationId not present in To or Fromurl  and route are different scroll to the top
  if (
    (!to.query.destinationId && !from.query.destinationId) ||
    to.name !== from.name
  ) {
    window.scrollTo(0, 0);
  }

  if (process.env.VUE_APP_SENTRY_ENVIRONMENT === "production") {
    window._paq.push(["setCustomUrl", `/${to.fullPath}`]);
    window._paq.push(["setDocumentTitle", to.name]);
    window._paq.push(["deleteCustomVariables", "page"]);
    window._paq.push(["setGenerationTimeMs", 0]);
  }

  // Check if allowed to enter in the route
  const accessToken = localStorage.getItem("access_token");
  const loggedIn = typeof accessToken === "string" && accessToken.length > 0;
  if (
    to.matched.some((record) => record.meta.requiresAuth && !loggedIn) ||
    to.matched.some((record) => record.meta.requiresNoAuth && loggedIn)
  ) {
    next({ name: "home" });
  } else {
    next();
  }
});

export default router;
